import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitGradeproId = async (gradeProId = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!gradeProId) {
        console.log("no gradeProId");
        return null;
    }
    console.log("CALLING SERVER with convertgradepro")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'convertgradepro',
            'apiToken': apiToken,
            'gradeProId': gradeProId,
            'addToDatabase': true
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from convertgradepro call");
    }).catch((error) => { console.log(error); });
};

export default submitGradeproId;